<template>
  <!-- 只允许一个组件 -->
  <a-layout class="center-container" style="background-color: #fff;">

    <!-- 居中显示 -->
    <div class="center-div" style="position: relative;">

      <!-- 树形列表,文章列表树 -->
      <!-- Affix 固钉 将页面元素钉在可视范围。-->
      <a-affix :offset-top="10">
        <a-layout-sider width="300px"
          :style="{ overflow: 'auto', height: '90vh', position: 'absolute', background: '#fff', left: 0, top: '65px', bottom: 0 }"
          style="margin-bottom: 150px;">
          <a-tree :show-line="true" :show-icon="true" v-if="level1.length > 0" :tree-data="level1" @select="onSelect"
            :replaceFields="{ label: 'name', title: 'name', key: 'id', value: 'id' }" :defaultExpandAll="true"
            :defaultSelectedKeys="defaultSelectedKeys" style="margin-left: 10px;">
          </a-tree>
          <!-- 空数据显示 tip="Loading..." -->
          <a-spin v-if="loading" style="margin-top: 150px;margin-left: 140px;" />
        </a-layout-sider>
      </a-affix>

      <!-- 中间内容 -->
      <a-layout-content :style="{ background: '#fff', padding: '75px 24px 24px 24px', margin: 0, minHeight: '720px' }"
        style="margin-left: 300px;">
        <h3 v-if="!loading && level1.length === 0">对不起，找不到相关文档！</h3>
        <h3 v-if="loading">加载文档中，请稍后...</h3>
        <!-- 右侧文档内容 -->
        <div style="margin-left: 0px;">

          <!-- 文档位置: 面包屑 -->
          <a-row :gutter="24">
            <a-breadcrumb separator=">" style="margin:0px 0px 20px 10px;">
              <a-breadcrumb-item>
                <router-link :to="'/'">
                  首页
                </router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>
                <!-- "{ path: '/', query: { categoryId: ebook.category1.id } }" -->
                <!-- "'/?categoryId=' + ebook.category1.id" -->
                <router-link
                  :to="{ path: '/', query: { 'id1': ebook.category1.id, 'id2': ebook.category2.id, 'type': 1 } }">
                  {{ ebook.category1.name }}
                </router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>
                <router-link
                  :to="{ path: '/', query: { 'id1': ebook.category1.id, 'id2': ebook.category2.id, 'type': 2 } }">
                  {{ ebook.category2.name }}
                </router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>{{ ebook.name }}</a-breadcrumb-item>
            </a-breadcrumb>
          </a-row>

          <!-- 文档详情 -->
          <div>
            <h2>{{ doc.name }}</h2>
            <div>
              <span>阅读数：{{ doc.viewCount }}</span> &nbsp; &nbsp;
              <span>点赞数：{{ doc.voteCount }}</span>
            </div>
            <a-divider style="height: 2px; background-color: #9999cc" />
          </div>

          <div class="wangeditor" :innerHTML="html"></div>

          <div class="vote-div">
            <a-button type="primary" shape="round" :size="'large'" @click="vote">
              <template #icon>
                <LikeOutlined /> &nbsp;点赞：{{ doc.voteCount }}
              </template>
            </a-button>
          </div>
        </div>

        <!-- 底部 -->
        <TheFooter></TheFooter>

      </a-layout-content>
    </div>
    <!-- 返回页面顶部的操作按钮。 -->
    <a-back-top type="default" />

  </a-layout>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";

// 引入公共样式
import '@/styles/mystyle.css'

// 引入代码高亮CSS atom-one-dark-reasonable.css
import 'highlight.js/styles/xcode.css' // xcode.css

import TheFooter from "@/components/the-footer.vue";


export default defineComponent({
  name: 'Doc',
  components: {
    TheFooter
  },
  setup() {
    const route = useRoute();
    const docs = ref();
    const html = ref();
    const defaultSelectedKeys = ref();
    defaultSelectedKeys.value = [];
    // 当前选中的文档
    const doc = ref();
    doc.value = {
      name: '',
      viewCount: 0,
      voteCount: 0
    };

    // 所属电子书
    const ebook = ref({
      name: "未知",
      category1: {
        name: "未知",
        id: undefined,
      },
      category2: {
        name: "未知",
        id: undefined,
      }
    })

    // 加载数据
    const loading = ref(false)

    /**
     * 查询电子书详情
     * 首页 > 前端开发 > HTML&CSS > Vue 入门教程2
     */
    const handEbookQuery = () => {
      loading.value = true
      axios.get("/ebook/detail/" + route.query.ebookId).then((response) => {
        loading.value = false
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          ebook.value = result.data;
          console.log("ebook ", ebook.value);
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 一级文档树，children属性就是二级文档
     * [{
     *   id: "",
     *   name: "",
     *   children: [{
     *     id: "",
     *     name: "",
     *   }]
     * }]
     */
    const level1 = ref(); // 一级文档树，children属性就是二级文档
    level1.value = [];

    /**
     * 内容查询
     **/
    const handleQueryContent = (id: number) => {
      loading.value = true
      axios.get("/doc/find-content/" + id).then((response) => {
        loading.value = false
        const result = response.data;
        console.log('html result ==> ', result)
        if (result.code == 0 && result.message == 'success') {
          html.value = result.data;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 数据查询
     **/
    const handleQuery = () => {
      loading.value = true
      axios.get("/doc/all/" + route.query.ebookId).then((response) => {
        loading.value = false
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          docs.value = result.data.list;

          level1.value = [];
          level1.value = Tool.array2Tree(docs.value, 0);

          if (Tool.isNotEmpty(level1) && Tool.isNotEmpty(level1.value[0])) {
            defaultSelectedKeys.value = [level1.value[0].id];
            handleQueryContent(level1.value[0].id);
            // 初始显示文档信息
            doc.value = level1.value[0];
          }
        } else {
          message.error(result.message);
        }
      });
    };

    //function(selectedKeys, e:{selected: bool, selectedNodes, node, event})
    const onSelect = (selectedKeys: any, info: any) => {
      console.log('selected', selectedKeys, info);
      if (Tool.isNotEmpty(selectedKeys)) {
        // 选中某一节点时，加载该节点的文档信息
        doc.value = info.selectedNodes[0]; //selectedNodes[0].props => selectedNodes[0]
        console.log('doc => ', doc)
        // 加载内容
        handleQueryContent(selectedKeys[0]);
      }
      // 文档置顶
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    };

    // 点赞
    const vote = () => {
      // 必须有值才可点赞
      if (doc.value == undefined || doc.value.id == undefined) {
        message.warning('暂无相关文档');
        return
      }
      axios.get('/doc/vote/' + doc.value.id).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          doc.value.voteCount++;
          //提示
          message.success("点赞成功");
        } else {
          message.warning(result.message);
        }
      });
    };

    onMounted(() => {
      handEbookQuery();
      handleQuery();
    });

    return {
      loading,
      level1,
      html,
      onSelect,
      defaultSelectedKeys,
      doc,
      vote,
      ebook
    }
  }
});
</script>

<style>
/* wangeditor默认样式*/
/* table 样式 */
.wangeditor table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.wangeditor table td,
.wangeditor table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

.wangeditor table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
.wangeditor blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
.wangeditor code {
  display: inline-block;
  display: inline;
  zoom: 1;
  /* background-color: #f1f1f1; */
  /* code代码块的背景颜色  #F2F6FC EBEEF5 E4E7ED*/
  /* background-color: #F2F6FC; */
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

.wangeditor pre code {
  display: block;
}

/* ul ol 样式 */
.wangeditor ul,
ol {
  margin: 10px 0 10px 20px;
}

/* 和antdv p冲突，覆盖掉 */
.wangeditor blockquote p {
  font-family: "YouYuan";
  margin: 20px 10px !important;
  font-size: 16px !important;
  font-weight: 600;
}

/* 点赞 */
.vote-div {
  padding: 15px;
  text-align: center;
}

/* 图片自适应 */
.wangeditor img {
  max-width: 100%;
  height: auto;

}


/* 视频自适应 */
.wangeditor iframe {
  width: 100%;
  height: 400px;
}
</style>
